/* @flow */

export default {
  HEADLINE_CONTACT_PERSON_OPENING_HOURS: 'ddw.headline.openingHours.label',
  PORTFOLIO_OPENING_HOURS_CLOSED: 'ddw.portfolio.openingHours.closed',
  PORTFOLIO_DEALER_CONTACTS: 'ddw.portfolio.dealer.contacts',
  PORTFOLIO_DEALER_OPENING_HOURS: 'ddw.portfolio.dealer.openingHours',
  DEALER_IMAGE: 'dealer.baseInfo.image',
  DEALER_FALLBACK_IMAGE: 'dealerFallbackImage',
  PERSON_FALLBACK_IMAGE: 'personFallbackImage',
  DEALER_NAME_LINE_1: 'dealer.baseInfo.name1',
  DEALER_NAME_LINE_2: 'dealer.baseInfo.name2',
  DEALER_NAME_LINE_3: 'dealer.baseInfo.name3',
  DEALER_NAME_LINE_4: 'dealer.baseInfo.name4',
  DEALER_NAME_LINE_5: 'dealer.baseInfo.name5',
  DEALER_ADDRESS_LINE_1: 'dealer.address.line1',
  DEALER_ADDRESS_LINE_2: 'dealer.address.line2',
  DEALER_ADDRESS_LINE_3: 'dealer.address.line3',
  DEALER_ADDRESS_CITY: 'dealer.address.city',
  DEALER_ADDRESS_ZIPCODE: 'dealer.address.zipcode',
  DEALER_ADDRESS_CITY_ADDON_1: 'dealer.address.cityAddon1',
  DEALER_ADDRESS_CITY_ADDON_2: 'dealer.address.cityAddon2',
  DEALER_CONTACT_LIST: 'dealer.contact.list',
  DEALER_CONTACT_NAME: 'dealer.contact.name',
  DEALER_CONTACT_PHONE: 'dealer.contact.phone',
  DEALER_CONTACT_FAX: 'dealer.contact.fax',
  DEALER_CONTACT_EMAIL: 'dealer.contact.email',
  DEALER_CONTACT_HOMEPAGE: 'dealer.contact.homepage',
  DEALER_PERSON_IMAGE: 'dealer.person.image',
  C_CTA_LIST: 'ddw.cta.list',
  C_PORTFOLIO: 'ddw.portfolio',
  C_CONTACTS: 'ddw.contacts',
  C_MAP: 'ddw.map',
  LINK_LIST: 'ddw.link.list',
  LINK_HOMEPAGE_CTA: 'ddw.link.homepage.cta.label',
  LINK_HOMEPAGE_CTA_URL: 'ddw.link.homepage.cta.url',
  LINK_EMAIL_CTA: 'ddw.link.email.cta.label',
  LINK_EMAIL_CTA_URL: 'ddw.link.email.cta.url',
  LINK_ROUTE_CTA: 'ddw.link.route.cta.label',
  LINK_ROUTE_CTA_URL: 'ddw.link.route.cta.url',
  LINK_HOMEPAGE: 'ddw.link.homepage.label',
  LINK_HOMEPAGE_URL: 'ddw.link.homepage.url',
  LINK_ONLINE_SHOP: 'ddw.link.onlineShop.label',
  LINK_ONLINE_SHOP_URL: 'ddw.link.onlineShop.url',
  LINK_ONLINE_SERVICE: 'ddw.link.onlineService.label',
  LINK_ONLINE_SERVICE_URL: 'ddw.link.onlineService.url',
  LINK_LOCATION: 'ddw.link.location.label',
  LINK_LOCATION_URL: 'ddw.link.location.url',
  LINK_CALLBACK: 'ddw.link.callback.label',
  LINK_CALLBACK_URL: 'ddw.link.callback.url',
  LINK_SEND_REQUEST: 'ddw.link.sendRequest.label',
  LINK_SEND_REQUEST_URL: 'ddw.link.sendRequest.url',
  LINK_TEST_DRIVE: 'ddw.link.testDrive.label',
  LINK_TEST_DRIVE_URL: 'ddw.link.testDrive.url',
  LINK_CUSTOM_1: 'ddw.link.custom1.label',
  LINK_CUSTOM_1_URL: 'ddw.link.custom1.url',
  LINK_CUSTOM_2: 'ddw.link.custom2.label',
  LINK_CUSTOM_2_URL: 'ddw.link.custom2.url',
  LINK_CUSTOM_3: 'ddw.link.custom3.label',
  LINK_CUSTOM_3_URL: 'ddw.link.custom3.url'
};
